import React from 'react'

/** Spread onto a non-<button> element (a table row or list-item div) that
 * acts as a clickable "open detail" row — makes it keyboard-operable
 * (Enter/Space) and announced as a button to assistive tech, matching the
 * existing onClick behavior exactly. Nested interactive controls (buttons,
 * selects) should keep stopping propagation on their own onClick, same as
 * before this was added. */
export function clickableRowProps(onActivate: () => void) {
  return {
    onClick: onActivate,
    onKeyDown: (e: React.KeyboardEvent) => {
      // Keydown bubbles independently of click, so a nested real button/select
      // (which stops click propagation in its own onClick, same as before this
      // helper existed) would still bubble an Enter/Space keydown up here —
      // only handle it when the row itself is the actual event target.
      if (e.target !== e.currentTarget) return
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        onActivate()
      }
    },
    role: 'button' as const,
    tabIndex: 0,
  }
}
